export default __webpack_public_path__ + "static/media/photo_icon.ca645ad3.svg";